import { Injectable, inject, Signal } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs/operators';
import * as Paths from '../constants';

@Injectable({ providedIn: 'root' })
export class RouteHelperService {
  private router = inject(Router);

  route$: Signal<string> = toSignal(
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.router.url),
    ),
    { initialValue: this.router.url },
  );

  isCybersecurityCockpit = () => this.route$().includes(Paths.CYBERSECURITY_COCKPIT_PATH);
  isPartnerCockpit = () => this.route$().includes(Paths.PARTNER_COCKPIT_PATH);
  isAdminCockpit = () => this.route$().includes(Paths.ADMIN_COCKPIT_PATH);

  getCockpitType(): 'customer' | 'partner' | 'admin' | 'unknown' {
    if (this.isAdminCockpit()) return 'admin';
    if (this.isPartnerCockpit()) return 'partner';
    if (this.isCybersecurityCockpit()) return 'customer';
    return 'unknown';
  }

  isAnyCockpit = () => this.isAdminCockpit() || this.isPartnerCockpit() || this.isCybersecurityCockpit();
}
